"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStyles = function (props) {
    var className = props.className, isNotHost = props.isNotHost;
    return ({
        root: [
            'ms-Layer',
            isNotHost && [
                'ms-Layer--fixed',
                {
                    position: 'fixed',
                    zIndex: 1000000,
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    visibility: 'hidden'
                }
            ],
            className
        ],
        content: [
            'ms-Layer-content',
            {
                visibility: 'visible'
            }
        ]
    });
};
//# sourceMappingURL=Layer.styles.js.map